module.exports = __webpack_public_path__ + "img/008.afd86cba.jpg";